import React from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { ellipsis } from 'polished'

interface ItemProps {
  isActive: boolean
  isSelected: boolean
  isDisabled: boolean
  itemContainerCss?: string
  itemActiveContainerCss?: string
  itemTextCss?: string
  itemSelectedTextCss?: string
  children: React.ReactChild
}

const defaultContainerCss = css`
  user-select: none;
  cursor: pointer;
  padding: 3px 10px;
  background-color: ${theme.color.white};
`

const disabledContainerCss = css`
  cursor: default;
  pointer-events: none;
`

const activeContainerCss = css`
  background-color: ${theme.color.teal10};
  transition: background-color 0.4s ease 0s;
`

const defaultItemTextCss = css`
  font-weight: normal;
  ${ellipsis()};
  display: inherit;
`

const defaultSelectedItemTextCss = css`
  font-weight: bold;
`

export function Item({
  isSelected,
  isActive,
  isDisabled,
  itemContainerCss,
  itemActiveContainerCss,
  itemTextCss,
  itemSelectedTextCss,
  ...rest
}: ItemProps) {
  return (
    <div
      className={cx(
        'legacy-ds-dropdown-menu-item',
        defaultContainerCss,
        itemContainerCss,
        {
          [cx(
            'legacy-ds-dropdown-menu-item-active',
            activeContainerCss,
            itemActiveContainerCss
          )]: isActive,
          [disabledContainerCss]: isDisabled
        }
      )}
    >
      <div
        className={cx(itemTextCss, defaultItemTextCss, {
          [cx(defaultSelectedItemTextCss, itemSelectedTextCss)]: isSelected
        })}
        {...rest}
      />
    </div>
  )
}
